// Foto REALI di Simon O. — Simone Orfanò.
// Struttura: { src, w, h, alt, quote, author? }

const local = (path, w, h, alt, quote, author) => ({ src: path, w, h, alt, quote, author });

// -------- HERO (rotazione ogni 7s) --------
export const HERO_PHOTOS = [
  local("/photos/bw/dsc-01259-2.webp", 1379, 2000, "Barbiere con occhiali che pettina", "Il tempo, in barberia, si ferma."),
  local("/photos/bw/sim-04442-2.webp", 2000, 1514, "Rasatura con rasoio nel collo", "Il rasoio scrive una firma."),
  local("/photos/bw/dsc-01198-2.webp", 1333, 2000, "Ritratto con occhiali", "Sguardo che si affida."),
  local("/photos/bw/a7v-00096.webp", 1333, 2000, "Barbiera al lavoro", "Le mani sanno più della voce."),
  local("/photos/bw/sim-04384.webp", 2000, 1333, "Forbici e barba, ravvicinata", "Precisione millimetrica."),
];

// -------- COLLEZIONI (tutte in bianco & nero) --------
// Le foto sono divise provvisoriamente in 3 gruppi. Le altre verranno aggiunte
// non appena Simon le carica. Ogni collezione ha slug, titoli IT/EN,
// sottotitolo evocativo, kicker (numero + label) e array di foto.
export const COLLECTIONS = [
  {
    slug: "oltre-il-colore",
    number: "01",
    titleIt: "Oltre il colore",
    titleEn: "Beyond Color",
    subtitleIt: "Il gesto, prima di tutto",
    subtitleEn: "The gesture, first of all",
    photos: [
      local("/photos/bw/dsc-01259-2.webp", 1379, 2000, "Barbiere con occhiali che pettina", "Il rito del pettine."),
      local("/photos/bw/sim-04442-2.webp", 2000, 1514, "Rasatura sul collo", "Il gesto che non trema."),
      local("/photos/bw/sim-04384.webp", 2000, 1333, "Forbici e barba", "Precisione millimetrica."),
      local("/photos/bw/img-6051.webp", 2000, 1333, "Barba, pettine e forbici in primo piano", "La barba, un centimetro alla volta."),
      local("/photos/bw/sim00156-2.webp", 2000, 1068, "Mano con pettine, chiaroscuro", "Anche la mano ha un suo respiro."),
      local("/photos/bw/sim01072.webp", 2000, 1460, "Rasoio a mano libera sulla mandibola", "Un solo colpo, deciso."),
      local("/photos/bw/sim02041-2.webp", 1333, 2000, "Rasatura con dita che tirano la pelle e schiuma", "La pelle si affida, la mano risponde."),
      local("/photos/bw/sim03420.webp", 2000, 1333, "Forbici e pettine largo che tagliano in controluce", "La lama, il pettine, la luce."),
      local("/photos/bw/sim02514-2.jpg", 1796, 1405, "Macro di rasoio con sapone e capelli ricci", "Un dettaglio che nessuno guarda mai."),
      local("/photos/bw/sim02999.webp", 2000, 1333, "Rasoio che segna la riga sui capelli", "Una linea, e il volto cambia."),
      local("/photos/bw/sim04501.webp", 2000, 1333, "Forbici e pettine da barbiere su capelli grigi", "Il tempo si legge nei capelli."),
      local("/photos/bw/sim04569.webp", 1607, 2000, "Rasatura del viso, mano rovesciata con rasoio", "La lama sfiora, il volto si consegna."),
      local("/photos/bw/sim04721-2.webp", 1333, 2000, "Forbici sospese sopra il pettine, mano con anelli", "L'attimo prima del taglio."),
      local("/photos/bw/sim08335-2.jpg", 1295, 1237, "Macro estrema della testina del tagliacapelli sulla barba", "Dove il metallo incontra il pelo."),
      local("/photos/bw/sim08520-2.webp", 2000, 1333, "Rasatura di barba folta grigia con rasoio, cliente rovesciato", "La lama traccia il confine, la barba si arrende."),
    ],
  },
  {
    slug: "anima-del-nero",
    number: "02",
    titleIt: "L'anima del nero",
    titleEn: "The Soul of Black",
    subtitleIt: "Ritratti e atmosfere",
    subtitleEn: "Portraits and atmospheres",
    photos: [
      local("/photos/bw/dsc-01198-2.webp", 1333, 2000, "Ritratto con occhiali", "Sguardo che si affida."),
      local("/photos/bw/a7v-00071-2.webp", 1333, 2000, "In attesa, sguardo basso", "Il silenzio prima del taglio."),
      local("/photos/bw/dsc-01190-2.webp", 1333, 2000, "Dettaglio ritratto", "Un mestiere che si eredita."),
      local("/photos/bw/img-0691.webp", 2000, 1333, "Uomo con cappello al caffè, controluce", "Il tempo di un aperitivo, in silhouette."),
      local("/photos/bw/sim01800.webp", 2000, 1576, "Testa con asciugamano al viso, luce bassa", "Nel buio, un momento che si posa."),
      local("/photos/bw/sim02489.webp", 1695, 2000, "Viso rilassato sotto asciugamano caldo con vapore", "Il vapore, il silenzio, e nient'altro."),
      local("/photos/bw/sim02518.webp", 2000, 1333, "Rasoio a coltello che rifinisce capelli ricci, sfondo scuro", "Un gesto piccolo, in un mondo grande."),
      local("/photos/bw/sim04203.webp", 2000, 1333, "Mano con anello che rifinisce dietro l'orecchio, occhi chiusi", "Ci si lascia guidare, senza guardare."),
      local("/photos/bw/sim06131-2.webp", 2000, 1333, "Rasoio che rifinisce la barba grigia in chiaroscuro", "Anche il tempo si posa, quando si lavora così."),
      local("/photos/bw/sim04912-2.webp", 1333, 2000, "Silhouette con vapore d'acqua in controluce", "Un respiro che sale, e non torna."),
      local("/photos/bw/sim07648-2.webp", 2000, 1333, "Rasoio a coltello che rifinisce una barba folta grigia", "Il rasoio, e una vita che si racconta."),
      local("/photos/bw/sim07971.webp", 1333, 2000, "Tagliacapelli con luci bokeh in ambiente scuro", "Il lavoro continua, anche quando cala la luce."),
    ],
  },
  {
    slug: "istanti-senza-tempo",
    number: "03",
    titleIt: "Istanti senza tempo",
    titleEn: "Timeless Moments",
    subtitleIt: "Ciò che accade tra un taglio e l'altro",
    subtitleEn: "What happens between one cut and the next",
    photos: [
      local("/photos/bw/sim-04324-2.webp", 1404, 2000, "Cliente al telefono", "Concentrazione, quasi religiosa."),
      local("/photos/bw/a7v-00096.webp", 1333, 2000, "Barbiera al lavoro", "Le mani sanno più della voce."),
      local("/photos/bw/img-6028.webp", 2000, 1484, "Lavaggio testa al lavandino", "Ci si abbandona all'acqua."),
      local("/photos/bw/img-6089.webp", 2000, 1333, "Asciugatura con asciugamano, pollice in su", "Un piccolo ok, e si riparte."),
      local("/photos/bw/sim00280-2.webp", 2000, 1333, "Forbici viste dall'alto sui capelli", "Uno sguardo che nessuno vede mai."),
      local("/photos/bw/sim01159-3.webp", 2000, 1277, "Forbici che tagliano con bokeh", "Il taglio, e la luce che lo accompagna."),
      local("/photos/bw/sim03510.webp", 1333, 2000, "Tagliacapelli elettrico che rifinisce la tempia, volto sfocato", "Sotto la macchinetta, il mondo si ferma."),
      local("/photos/bw/sim03514.webp", 2000, 1333, "Macro del rasoio safety chiuso su capelli ricci", "Anche gli attrezzi hanno un ritratto."),
      local("/photos/bw/sim07040-2.webp", 2000, 1333, "Cliente sdraiato con asciugamano sul viso, poltrona da barbiere in ambiente di pietra", "Fermarsi. Solo per un momento."),
      local("/photos/bw/sim07067.webp", 2000, 1268, "Tagliacapelli con pettine di appoggio che rifinisce la barba", "Ogni linea, un accordo silenzioso."),
      local("/photos/bw/sim08443-2.webp", 2000, 1333, "Forbici sospese in aria, ciocca di capelli bagnati tra le dita", "Un attimo prima che il taglio accada."),
      local("/photos/bw/sim08581-2.webp", 2000, 1245, "Affilatura del rasoio sulla pietra giapponese bagnata", "Prima di tagliare, si affila. Sempre."),
    ],
  },
];

export const getCollectionBySlug = (slug) => COLLECTIONS.find((c) => c.slug === slug);

// -------- PORTRAIT (placeholder finché non arriva la foto di Simone) --------
export const PORTRAIT = {
  src: "/photos/bw/dsc-01190-2.webp",
  alt: "Simone Orfanò — Simon O.",
};
